/**
 * @generated SignedSource<<a549b8bf962675110ca6dc49ce4e2731>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TransferLemonIdMutation$variables = {
  email: string;
  userId: string;
};
export type TransferLemonIdMutation$data = {
  readonly transferLemonId: {
    readonly email: string | null;
    readonly id: string;
    readonly name: string | null;
  };
};
export type TransferLemonIdMutation = {
  response: TransferLemonIdMutation$data;
  variables: TransferLemonIdMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "email"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      },
      {
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
      }
    ],
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "transferLemonId",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TransferLemonIdMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TransferLemonIdMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "1557422c0df79530d28c4e9eb205b15a",
    "id": null,
    "metadata": {},
    "name": "TransferLemonIdMutation",
    "operationKind": "mutation",
    "text": "mutation TransferLemonIdMutation(\n  $userId: String!\n  $email: String!\n) {\n  transferLemonId(userId: $userId, email: $email) {\n    id\n    name\n    email\n  }\n}\n"
  }
};
})();

(node as any).hash = "b677b515c5202e62c12b733ef5d49bef";

export default node;
